<template>
    <div>
        <h2>
            Geneaologia Katedry
        </h2>

        <img src="@/assets/geneaologia.jpg"/>
    </div>
</template>

<script>
export default {
  name: 'geneaology',
};
</script>

<style scoped>
    div {
        display: block;
        width:100%;
        height: 80%;
        background-color: white;
    }

    img {
        width: 80%;
        margin: 20px;
    }
</style>
